// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueWait from 'vue-wait'
import 'babel-polyfill'
import App from './App'
import router from './router'
import { ButtonPlugin, SpinnerPlugin, CollapsePlugin, CardPlugin, NavbarPlugin } from 'bootstrap-vue'
import store from './store'
import moment from 'moment'
import './css/app.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown, faCaretUp, faCaretRight, faChevronDown, faChevronUp, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

moment.locale('ja')
Vue.config.productionTip = false

Vue.use(ButtonPlugin)
Vue.use(SpinnerPlugin)
Vue.use(CollapsePlugin)
Vue.use(CardPlugin)
Vue.use(NavbarPlugin)
Vue.use(VueWait)

library.add(faCaretDown)
library.add(faCaretUp)
library.add(faCaretRight)
library.add(faChevronDown)
library.add(faChevronUp)
library.add(faChevronRight)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.filter('datetime', val => val === null || val === undefined || val === '' ? '' : moment(val).format('YYYY/MM/DD HH:mm'))
Vue.filter('jpfulltime', val => val === null || val === undefined || val === '' ? '' : moment(val).format('YYYY年M月D日(dd) HH時mm分'))
Vue.filter('jpmonthday', val => val === null || val === undefined || val === '' ? '' : moment(val).format('M月D日(dd)'))
Vue.filter('jpYYYYMMDDdd', val => val === null || val === undefined || val === '' ? '' : moment(val).format('YYYY年M月D日(dd)'))
Vue.filter('date', val => val === null || val === undefined || val === '' ? '' : moment(val).format('YYYY/MM/DD'))
Vue.filter('int2time', val => val === null || val === undefined || val === '' ? '' : `${Math.floor(val / 100).toString().padStart(2, '0')}:${(val % 100).toString().padStart(2, '0')}`)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  wait: new VueWait({
    useVuex: true,
    vuexModuleName: 'wait',
    registerComponent: true,
    componentName: 'v-wait',
    registerDirective: true,
    directiveName: 'wait'
  })
})



// WEBPACK FOOTER //
// ./src/main.js